'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'eSignature Free SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Use eSignatures for Free',
            subtitle: 'Send your first eSignature for free',
            buttonText: 'Create a Free Account'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'Can I use HelloSign eSignatures for free?'), _jsx('p', {}, void 0, 'You can begin signing documents for free by signing up for a HelloSign account. Our starter plan gives you three free eSignature requests per month and access to our user-friendly signer experience. You can upgrade to any pro plan or above for unlimited signatures.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What happens if I need more than three signature requests?'), _jsx('p', {}, void 0, 'Your first three signature requests are free. With an upgraded plan, you can send unlimited signature requests and enjoy HelloSign templates to format your frequently used documents. ', _jsx('a', {
            target: '_blank_',
            href: 'https://www.hellosign.com/info/pricing'
        }, void 0, 'Learn more about our plans here.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'How can I use free eSignatures to sign documents online?'), _jsx('p', {}, void 0, 'It’s simple to start signing for free! Once you’ve activated a HelloSign account, you can begin your first signature request. Start by uploading the document you’d like to have signed and format it with a signature field. Format other fields like name of signer and custom signature request message, then send your doc.'), _jsx('p', {}, void 0, 'You’ll receive automatic email reminders to update you on the progress of the document.'), _jsx('p', {}, void 0, 'You can see what a signature request looks like from the signer’s perspective ', _jsx('a', {
            target: '_blank',
            href: 'https://faq.hellosign.com/hc/en-us/articles/210929317-What-does-a-signature-request-look-like-from-the-signer-s-perspective-New-'
        }, void 0, 'here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How else can I use HelloSign?'), _jsx('p', {}, void 0, 'While we’re the fastest and easiest way to get documents signed online, we’re also proud to offer a bunch of handy tools to our users. These include:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Document templates.'), ' Templates save you the trouble of re-formatting your frequently used documents over and over. Simply upload a document, format with the appropriate fields, then save as a template you can use again and again.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Integrations.'), ' HelloSign also makes it easy to sign paper in your existing apps. This means you can sign documents in apps like ', _jsx('a', {
            target: '_blank',
            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/'
        }, void 0, 'Evernote'), ',', _jsx('a', {
            href: 'http://blog.hellosign.com/dropbox/',
            target: '_blank'
        }, void 0, 'Dropbox'), ', Google (including ', _jsx('a', {
            href: 'https://www.hellosign.com/gmail',
            target: '_blank'
        }, void 0, 'Gmail'), ', ', _jsx('a', {
            href: 'https://www.hellosign.com/googledrive',
            target: '_blank'
        }, void 0, 'Google Drive'), ', and ', _jsx('a', {
            href: 'https://www.hellosign.com/google-docs-add-on',
            target: '_blan'
        }, void 0, 'Google Docs'), ').'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Mobile Signing.'), ' Our signer experience was created with multiple devices in mind. That means it’s easy to sign contracts or paperwork on the go from your desktop, tablet, or mobile device.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'How is HelloSign different from other free eSignature apps?'), _jsx('p', {}, void 0, 'The thing that sets HelloSign apart from the rest is our straightforward and friendly signer experience. We are and have always been focused on giving our users the best signing experience possible. That means providing an easy-to-navigate and intuitive signer page that guides users smoothly through the signing flow.'), _jsx('p', {}, void 0, 'For you as a signer, that means a more pleasant signing experience and an overall better user experience. To read more about our signer page updates, ', _jsx('a', {
            href: 'http://blog.hellosign.com/new-signer-experience/',
            target: '_blank'
        }, void 0, 'visit here'), '.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Start signing! You can sign up for a free account to test out any of our plans. If you want to connect with a HelloSign specialist to learn more about our business and team plans, schedule a demo.',
            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/e-signature-free.jsx
 ** module id = 810
 ** module chunks = 0
 **/